import React from 'react';
import { useState } from 'react';
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import moment from "moment";
import axios from 'axios';
import {IVR_INSTANT, CHANNEL_CLIENT_CHNLTYPE} from "../../constants";
import NotificationAlert from "react-notification-alert";

const initialValues={
  mobile:"",
  templateid:"",
  senderid:""

}
let templates = [];
let senderids = [];

let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
const InstantIvr = () => {
  const [ivrCampaign,setIvrCampaign] = useState(initialValues)
  
  const [isLoading, setIsLoading] = React.useState(false);
  const [channel, setChannel] = useState([]);
  
  const [errorhandle, setErrorHandle] = useState();

  const notificationAlertRef = React.useRef(null);


  React.useEffect(() => {
    fetchChanelsbyClient();
  }, []);

   //Fetching Template by IVR Channel
   
  const fetchChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "ivr",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          templates = [];
          const chnlObj = res?.data[0];

          setChannel(res?.data);
          setIvrCampaign({ ...ivrCampaign});

          res?.data?.map((item, i) => {
            item?.template &&
              templates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
         
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

  
  
  const changeSender = (data) => {
    sessionStorage.setItem("template", data.label);
    senderids = [];
    const chnl = channel?.filter((item) => item.template == data.value);

    const senderid = chnl[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      senderids.push({ label: senderid[i], value: senderid[i] });
    }

    setIvrCampaign((prev) => ({
      ...prev,
      templateid: data,
      senderid: "",
      

    }));
  };


  const validate = () => {
    let errors = {};
    
    if (ivrCampaign?.mobile?.length != 10) {
      errors.mobile = "Please Enter 10 digits Mobile Number";
    }
    // if (!ivrCampaign?.templateid?.value) {
    //   errors.templateid = "Please CallFlow";
    // }
    // if (!ivrCampaign?.senderid?.value) {
    //   errors.senderid = "Please Select Sender Id";
    // }
  

    return errors;
  };

  const submitIvr =()=>{
    const config = {
        headers: {
          "content-type": " application/json",
          "auth_id":user?.username+"#"+localStorage.getItem("password")
        },
      };
    const payload={
      msisdn:ivrCampaign.mobile,
      callflow:"http://google.com",
      // templateid:ivrCampaign?.templateid?.value,
      clientid: user?.client,
    
    }
   
    const isValid = validate();
    setErrorHandle(isValid);
    if (Object.keys(isValid).length == 0) {
      setIsLoading(true);
    axios.post(IVR_INSTANT, payload,config).then((response) => {
      let options = {};
      options = {
        place: "tr",
        message: "Saved Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
     // history.push('/ivrcampaignlist')
     setIvrCampaign(initialValues)
      console.log("success",response.data)}).catch(err=>console.log("err==>",err));
      setIsLoading(false);
    }
  }
  return (
    
    <>
    
      <div className="content">
        <Row>
      <Col md="12">
            <Card>
              
              
              <CardBody>
              <NotificationAlert ref={notificationAlertRef} />
                <Form action="#">
                <Row>
                  <Col md="3" sm='12'>
                    <label>Mobile Number *</label>
                    <FormGroup>
                      <Input type="number" placeholder='Enter Number' value={ivrCampaign.mobile} onChange={(e) =>setIvrCampaign({...ivrCampaign,mobile:e.target.value})} />
                    </FormGroup>
                    {errorhandle?.mobile && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.mobile}
                        </span>
                      )}
                  </Col>
                  <Col md="3" sm="12">
                      <p className="category">
                        Select CallFlow<suf style={{ color: "red" }}>*</suf>{" "}
                      </p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="templateSelect"
                        value={ivrCampaign.templateid}
                        onChange={(value) => changeSender(value)}
                        options={templates}
                        placeholder="Select"
                      />
                      {errorhandle?.templateid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.templateid}
                        </span>
                      )}
                    </Col>
                    <Col md="3" sm="12">
                      <p className="category">Select Sender Id</p>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderSelect"
                        value={ivrCampaign?.senderid}
                        onChange={(value) =>
                          setIvrCampaign((prev) => ({
                            ...prev,
                            senderid: value,
                          }))
                        }
                        options={senderids}
                        placeholder="Select"
                      />
                      {errorhandle?.senderid && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.senderid}
                        </span>
                      )}
                    </Col>
                
                  <Col md='1' sm='12'>
                  <Button 
                    color="primary "
                    className="mt-4 btn btn-icon animation-on-hover"
                    id="tooltipsubmit"
                    type="button"
                    onClick={()=>submitIvr()}
                        disabled={isLoading}
                  ><i className="tim-icons icon-double-right"  /></Button>
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltipsubmit"
                >
                  Submit
                </UncontrolledTooltip>
                  </Col>
                 
              </Row>
                  
                </Form>
              </CardBody>
              
            </Card>
          </Col>
          </Row>
      </div>
    </>
  )
}

export default InstantIvr

